document.addEventListener('DOMContentLoaded', () => {
  const checkoutButton = document.getElementById('checkout-button');
  const termsCheckbox = document.getElementById('terms-conditions-checkbox');
  const validationMessage = document.querySelector('.validation-message');

  checkoutButton.addEventListener('click', (e) => {
    e.preventDefault();

    if (!termsCheckbox.checked) {
      termsCheckbox.setAttribute('invalid', '');
      termsCheckbox.setAttribute('aria-invalid', 'true');
      validationMessage.classList.remove('hidden');
      return;
    }

    window.location.href = '/checkout';
  });

  // Remove invalid state when checkbox is checked, better UX
  termsCheckbox.addEventListener('change', () => {
    if (termsCheckbox.checked) {
      termsCheckbox.removeAttribute('invalid');
      termsCheckbox.removeAttribute('aria-invalid');
      validationMessage.classList.add('hidden');
    }
  });
});
